import { api_url } from "@/config/api_url";
import axios from 'axios';
import { defineStore } from "pinia";
import { useNotificationStore } from "./notificationStore";

export const useVehicleStore = defineStore('vehicleStore',{
    state:() => ({
        vehicles:[],
        vehicle:[],
        possibleVehicles:[],
        loading:false,
    }),

    actions:{

        async fetchVehicles(){
            this.loading = true;
            try {
                const result = await axios.get(`${api_url}/admin/vehicle/getAll`);
                this.vehicles = result.data.data;
                this.loading = false;
            } catch (error) {
                this.handleError(error);
                this.loading = false;
            }
        },

        async fetchVehicle(id){
            this.loading = true;
            try{
                const result = await axios.get(`${api_url}/admin/vehicle/${id}`);
                this.vehicle = result.data.data;
                this.loading = false;
            }catch (error) {
                this.handleError(error);
                this.loading = false;
            }
        },

        async fetchVehiclesOfMission(id){
            axios.defaults.headers.common = {
                Authorization: `${localStorage.getItem('token')}`
            };
            try{
                const result = await axios.get(`${api_url}/admin/mission/${id}/vehicles`);
                this.vehicles = result.data.data;
                this.loading = false;
            }catch (error) {
                this.handleError(error);
                this.loading = false;
            }
        },

        async fetchPossibleVehicles(id){
            axios.defaults.headers.common = {
                Authorization: `${localStorage.getItem('token')}`
            };
            try{
                const result = await axios.get(`${api_url}/admin/mission/${id}/vehicles/getPossibleVehicles`);
                this.possibleVehicles = result.data.data;
                this.loading = false;
            }catch (error) {
                this.handleError(error);
                this.loading = false;
            }
        },

        async createVehicle(newVehicle) {
            try {
                const response = await axios.post(`${api_url}/admin/vehicle`, newVehicle)
                this.vehicles = response.data.data;
                return response;
            } catch (error) {
                this.handleError(error);
            }
        },

        async editVehicle(editVehicle,id) {
            try {
                const response = await axios.put(`${api_url}/admin/vehicle/${id}`, editVehicle);
                this.vehicle = response.data.data;
                return response;
            } catch (error) {
                this.handleError(error);
            }
        },

        async assingVehicle(vehicleToAdd,missionId){
            try {
                const response = await axios.put(`${api_url}/admin/mission/${missionId}/vehicles/${vehicleToAdd}`);
                this.vehicles = response.data.data;
                return response;
            } catch (error) {
                this.handleError(error);
            }
        },

        async designVehicle(vehicleToDelete,missionId){
            try{
                const response = await axios.delete(`${api_url}/admin/mission/${missionId}/vehicles/${vehicleToDelete}`);
                this.vehicles = response.data.data
                return response;
            } catch (error) {
                this.handleError(error);
            }
        },

        async uploadDescriptive(id,descriptiveData){
            try {
                const response = await axios.put(`${api_url}/admin/vehicle/${id}/descriptive`,descriptiveData);
                this.vehicle = response.data.data;  
                return response;
            } catch (error) {
                this.handleError(error);
            }
        },

        async exportWaypoints(mission_id,vehicle_id){
            try {
                const response = await axios.get(`${api_url}/admin/vehicle/${vehicle_id}/waypoints/${mission_id}`); 
                return response.data.data;
            } catch (error) {
                this.handleError(error);
            }
        },

        async importWaypoints(mission_id,vehicle_id,data){
            try {
                const response = await axios.post(`${api_url}/admin/vehicle/${vehicle_id}/waypoints/${mission_id}`,data); 
                return response.data.data;
            } catch (error) {
                this.handleError(error);
                throw new Error(error);
            }
        },

        async changeVisibleDescriptive(id,descriptiveData){
            try {
                const response = await axios.put(`${api_url}/admin/vehicle/${id}/descriptive/visible`,descriptiveData);
                this.vehicle = response.data.data;  
                return response;
            } catch (error) {
                this.handleError(error);
            }
        },

        async deleteVehicle(id){
            try {
                const response = await axios.delete(`${api_url}/admin/vehicle/${id}`);
                this.vehicles = response.data.data;  
                return response;
            } catch (error) {
                this.handleError(error);
            }
        },
        
        handleError(error) {
            useNotificationStore().setNotification('Error', error.response.data.message, 'mdi-alert', 'error');
        },
    }
})